/**
 * Reducer pro nekonečný scroll - s podporou checkbox.
 */
import {TOGGLE, TOGGLE_ALL, CHECKED_ALL} from './InfiniteCheckListActions';
import {REMOVE} from './InfiniteListActions';
import InfiniteListReducer from "./InfiniteListReducer";
import getMapFromList from "../../utils/getMapFromList";
import getSetFromIdsList from "../../utils/getSetFromIdsList";

const initialState = {
    reducer: list,
    checkedIds: {}, // seznam vybraných id - mapa id na true
    allChecked: false,
    ...InfiniteListReducer()
};

function calcAllChecked(allIds, checkedIds) {
    for (let a=0; a<allIds.length; a++) {
        if (!checkedIds[allIds[a]]) {
            return false;
        }
    }
    return true;
}

export default function list(state = initialState, action = {}, config = null) {
    // Konfigurace
    if (config) {
        state = {
            ...state,
            ...InfiniteListReducer(undefined, {}, config),
            reducer: list,
        };
    }

    // Vlastní akce
    switch (action.type) {
        case TOGGLE: {
            let newCheckedIds;
            if (state.checkedIds[action.id]) {  // je vybraná
                newCheckedIds = {...state.checkedIds};
                delete newCheckedIds[action.id];
            } else {    // není vybraná
                newCheckedIds = {
                    ...state.checkedIds,
                    [action.id]: true
                };
            }
            return {
                ...state,
                checkedIds: newCheckedIds,
                allChecked: calcAllChecked(state.allIds, newCheckedIds)
            };
        }
        case TOGGLE_ALL: {
            if (state.allChecked) {
                return {
                    ...state,
                    checkedIds: {},
                    allChecked: false
                }
            } else {
                return {
                    ...state,
                    checkedIds: getSetFromIdsList(state.allIds),
                    allChecked: true
                };
            }
        }
        case CHECKED_ALL: {
            if (action.checked) {
                return {
                    ...state,
                    checkedIds: getSetFromIdsList(state.allIds),
                    allChecked: true
                };
            } else {
                return {
                    ...state,
                    checkedIds: {},
                    allChecked: false
                }
            }
        }
        case REMOVE: {
            const checkedIds = {...state.checkedIds};
            for (const id of action.ids) {
                delete checkedIds[id];
            }
            const allChecked = state.allChecked && action.ids.length === 0; // Zachovame příznak pokud bychom nic neubrali
            return {
                ...state,
                ...InfiniteListReducer(state, action),
                checkedIds,
                allChecked,
            };
        }
        default:
            return {
                ...state,
                ...InfiniteListReducer(state, action),
                reducer: list,
            }
    }
}
